import { brands } from "./constants";

export default function SuccessfulBrands() {
  return (
    <div className="px-4 md:p-4 flex flex-col justify-center items-center w-full">
      <h2 className="font-semibold text-2xl md:text-xl text-black text-center">
        Trusted by Global Brands to Find Their Perfect Workspace
      </h2>
      <div className="flex gap-16 mt-8 w-full justify-start overflow-x-auto scrollbar-hide scroll-smooth px-4">
        {brands.map((brand) => {
          // Generate ImageKit optimized URL for SVG brand logos
          const s3Url = `https://office-hub.s3.ap-southeast-2.amazonaws.com/site/assets/home-page/${brand}.svg`;
          // Use ImageKit to proxy and optimize the external SVG (keep as SVG format)
          const imageUrl = `https://ik.imagekit.io/officehub/tr:h-70,f-avif/${encodeURIComponent(s3Url)}`;

          return (
            <div className="flex justify-center min-w-24 md:min-w-32" key={brand}>
              <img
                src={imageUrl}
                alt={`${brand} logo`}
                title={brand}
                width={128}
                height={35}
                className="h-[35px] w-[128px] object-contain"
                loading="lazy"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
